// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MZSN","inner":"styles_inner__h5ykX","right":"styles_right__1SR-S","close":"styles_close__25qii","footer":"styles_footer__1oga7"};